import './index.scss';

const LSG_KEY_TIMESTAMP = '__ng_quark_popup_v2'; // 展示时间戳
const LSG_KEY_TIMES = '__ng_quark_popup_time_v2'; // 已经展示次数
const LSG_KEY_INS = '__ng_quark_popup_install'; // 是否点击过安装，点击后，除非清除localStorage，不然不会再展示
const LSG_KEY_DONT_TIPS = '__ng_quark_popup_dont_tips_v2'; // 是否点击过不再提示，点击后，除非清除localStorage，不然不会再展示
const MAX_TIME = 3; // 重复展示次数
// const SHOW_DELAY = 30; // 秒
// const TIMES_DELAY = 20 * 60;  // 秒
// // const TIMES_DELAY = 1 * 60;  // test

const NG_URL = 'https://www.9game.cn/yunyou/';
class QuarkPopup {
  constructor() {
    this.Init();
  }

  get popupDom() {
    return document.querySelector('.qak_popup');
  }

  get popupDownDom() {
    return document.querySelector('.JS_QAK_D');
  }

  // get popupTipsDom() {
  //   return document.querySelector('.JS_QAK_TIPS');
  // }

  get popupCloseDom() {
    return document.querySelector('.JS_QAK_CL');
  }

  get popupGZJump() {
    return document.querySelector('.JS_QAK_GZ');
  }

  get ch() {
    return $('.qak_popup').data('ch') || 'none';
  }

  isNextDay() {
    const prevShowTime = window.localStorage.getItem(LSG_KEY_TIMESTAMP);
    if (prevShowTime) {
      // console.log('isNextDay => prevShowTime', prevShowTime);
      const nowTime = new Date();
      const prevTime = new Date(Number(prevShowTime));
      // console.log('isNextDay => prevTime', prevTime);
      const now = nowTime.getTime();
      if (now >= Number(prevShowTime)) {
        // console.log('isNextDay => Number(prevShowTime) < now', Number(prevShowTime) < now);
        const prevYear = prevTime.getFullYear();
        const prevMonth = prevTime.getMonth();
        const prevDate = prevTime.getDate();
        const nowYear = nowTime.getFullYear();
        const nowMonth = nowTime.getMonth();
        const nowDate = nowTime.getDate();
        // console.log('isNextDay => prevYear', prevYear);
        // console.log('isNextDay => prevMonth', prevMonth);
        // console.log('isNextDay => prevDate', prevDate);
        // console.log('isNextDay => nowYear', nowYear);
        // console.log('isNextDay => nowMonth', nowMonth);
        // console.log('isNextDay => nowDate', nowDate);
        if (nowYear == prevYear) {
          if (nowMonth == prevMonth) {
            if (nowDate > prevDate) {
              return true;
            } else if (nowDate <= prevDate) {
              return false;
            }
          } else if (nowMonth > prevMonth) {
            return true;
          } else if (nowMonth < prevMonth) {
            return false;
          }
        } else if (nowYear > prevYear) {
          return true;
        } else if (nowYear < prevYear) {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  isNextTime() {
    const prevShowTime = window.localStorage.getItem(LSG_KEY_TIMESTAMP);
    if (prevShowTime) {
      // console.log('isNextTime => prevShowTime', prevShowTime);
      const nowTime = new Date();
      const now = nowTime.getTime();
      const diff = now - Number(prevShowTime);
      // console.log('isNextTime => diff', diff);
      // console.log('isNextTime => diff >= TIMES_DELAY * 1000', diff >= TIMES_DELAY * 1000);
      if (diff >= TIMES_DELAY * 1000) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  popupShow() {
    this.popupDom.classList.add('entry');
    this.popupDom.classList.remove('hide');
  }

  popupHide() {
    this.popupDom.classList.remove('entry');
    this.popupDom.classList.add('hide');
  }

  // autoShowV1() {
  //   this.popupShow();
  //   window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('qak_exp', 'exp', {});
  //   window.localStorage.setItem(LSG_KEY_TIMESTAMP, Date.now());
  //   const getTimes = window.localStorage.getItem(LSG_KEY_TIMES);
  //   // console.log('autoShow => getTimes', getTimes);
  //   // console.log('autoShow => getTimes ? Number(getTimes) + 1 : 1', getTimes ? Number(getTimes) + 1 : 1);
  //   window.localStorage.setItem(LSG_KEY_TIMES, getTimes ? Number(getTimes) + 1 : 1);
  //   setTimeout(() => {
  //     this.popupHide();
  //     setTimeout(() => {
  //       const getTimes = window.localStorage.getItem(LSG_KEY_TIMES);
  //       // console.log('autoShow => getTimes', getTimes);
  //       // console.log('autoShow => getTimes < MAX_TIME', getTimes < MAX_TIME);
  //       if (getTimes < MAX_TIME) {
  //         this.autoShow();
  //       }
  //     }, TIMES_DELAY * 1000);
  //   }, SHOW_DELAY * 1000);
  // }

  autoShow() {
    this.popupShow();
    window.localStorage.setItem(LSG_KEY_TIMESTAMP, Date.now());
    const getTimes = window.localStorage.getItem(LSG_KEY_TIMES);
    window.localStorage.setItem(LSG_KEY_TIMES, getTimes ? Number(getTimes) + 1 : 1);
    const miaonwanUrl = $('.JS_QAK_D').data('miaowan') || NG_URL;
    window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('cdgpopup_exp', 'exp', {
      styleType: miaonwanUrl == NG_URL ? 'homepage' : 'gamepage',
      game_ch: this.ch,
    });
  }
  
  clickDown() {
    // console.log('clickDown ===>');
    // const targrtUrl = 'https://download.quark.cn/download/quarkpc?platform=pc&ch=pcquark@other_jiuyoudlpckk_1';
    // const targrtUrl = 'https://b.quark.cn/apps/qkhomepage_twofoufeb/routes/model?entry=other_jiuyoudlpckk_1&ch=other_jiuyoudlpckk_1&image=search&dp=';
    // // window.location.href = targrtUrl;
    // window.open(targrtUrl);
    // this.popupHide();
    // window.localStorage.setItem(LSG_KEY_INS, '1');
    
    const miaonwanUrl = $('.JS_QAK_D').data('miaowan') || NG_URL;
    window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('cdgpopup_clk', 'clk', {
      target_url: miaonwanUrl,
      ck_url: 'link',
      styleType: miaonwanUrl == NG_URL ? 'homepage' : 'gamepage',
      game_ch: this.ch,
    });
    window.open(miaonwanUrl);
  }

  clickJump() {
    // console.log('clickDown ===>');
    // const targrtUrl = 'https://download.quark.cn/download/quarkpc?platform=pc&ch=pcquark@other_jiuyoudlpckk_1';
    // const targrtUrl = 'https://b.quark.cn/apps/qkhomepage_twofoufeb/routes/model?entry=other_jiuyoudlpckk_1&ch=other_jiuyoudlpckk_1&image=search&dp=';
    // // window.location.href = targrtUrl;
    // window.open(targrtUrl);
    // this.popupHide();
    // window.localStorage.setItem(LSG_KEY_INS, '1');
    const cdgUrl = $('.JS_QAK_GZ').data('cdgurl') || 'https://www.9game.cn/yunyou/';
    window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('cdgpopupjump_clk', 'clk', {
      target_url: cdgUrl,
      ck_url: 'link',
      styleType: cdgUrl == NG_URL ? 'homepage' : 'gamepage',
      game_ch: this.ch,
    });
    window.open(cdgUrl);
  }

  // clickTips() {
  //   // console.log('clickTips ===>');
  //   this.popupHide();
  //   window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('qak_tips_clk', 'clk', {
  //     target_url: 'none',
  //   });
  // }

  Init() {
    // const host = window.location.host;
    // if (host != 'www.9game.cn') {
    //   return;
    // }
    // 打开新页面时的处理
    this.popupDownDom.addEventListener('click', () => {
      this.clickDown();
    });
    this.popupGZJump.addEventListener('click', () => {
      this.clickJump();
    });
    // this.popupTipsDom.addEventListener('click', () => {
    //   // window.localStorage.setItem(LSG_KEY_DONT_TIPS, '1');
    //   this.clickTips();
    // });
    this.popupCloseDom.addEventListener('click', () => {
      // window.localStorage.setItem(LSG_KEY_DONT_TIPS, '1');
      this.popupHide();
      window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('qak_close_clk', 'clk', {
        target_url: 'none',
      });
    });
    // const prevShowTime = window.localStorage.getItem(LSG_KEY_TIMESTAMP);
    // if (prevShowTime) {
    //   const isND = this.isNextDay();
    //   if (isND) {
    //     // 如果是下一天 需要重新展示
    //     // window.localStorage.removeItem(LSG_KEY_DONT_TIPS);
    //     window.localStorage.removeItem(LSG_KEY_TIMES);
    //     this.autoShow();
    //   } else {
    //     // const isDontTips = window.localStorage.getItem(LSG_KEY_DONT_TIPS);
    //     const getTimes = window.localStorage.getItem(LSG_KEY_TIMES);
    //     if (Number(getTimes) >= MAX_TIME) {
    //       this.popupHide();
    //     } else {
    //       this.autoShow();
    //     }
    //   }
    // } else {
    //   this.autoShow();
    // }
    this.autoShow();
  }
}

new QuarkPopup();



// WEBPACK FOOTER //
// ./jws/views/page/pc_quark_popup/index.js